import websiteActiveLoyalty from '@data/queries/website/websiteActiveLoyalty.main'
import getWebsiteIdFromDomain from '@data/queries/website/websiteIdFromDomain'
import getWebsiteInitialData from '@data/queries/website/websiteInitialData.main'
import websiteSSRTranslations from '@helpers/misc/websiteSSRTranslations'
import AbstractLayout from '@page-components/Layout/AbstractLayout'
import Website from '@page-components/Layout/Website'
import LoyaltyProgram from '@page-components/LoyaltyProgram'
import NotFound from '@page-components/NotFound'
import NoWebsite from '@page-components/NoWebsite'
import {InferGetStaticPropsType} from 'next'

export default function LoyaltyPage(props: InferGetStaticPropsType<typeof getStaticProps>) {
  if (!props?.initialData?.website) {
    return <NoWebsite />
  }

  // At the moment this page will only work with the spoonity loyalty program.
  if (!props?.activeLoyalty || props?.activeLoyalty.name !== 'spoonity') {
    return <NotFound />
  }

  return (
    <AbstractLayout LayoutComponent={Website} >
      <LoyaltyProgram activeLoyalty={props.activeLoyalty} />
    </AbstractLayout>
  )
}

export const getStaticProps = async context => {
  const websiteId = await getWebsiteIdFromDomain(context.params.hostname)
  const initialData = await getWebsiteInitialData(websiteId)
  const {activeLoyalty} = await websiteActiveLoyalty(websiteId)

  return {
    props: {
      ...(await websiteSSRTranslations(context.params.hostname)),
      initialData,
      websiteId,
      activeLoyalty
    },
    revalidate: 60 * 60 * 24 // Revalidated on demand
  }
}

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: true
  }
}
